import Actions from '../../odata/actions';

const actions = new Actions('stage', 'stages');

export default actions;
